import { createI18n, useI18n } from "vue-i18n";
import { getTranslations } from "@/services/CostsCalculatorService";
import { getGlobalConfig } from "@/config/globalConfig";
import { TranslationResult } from "./interfaces/TranslationResult";

const generalErrorMessages = {
  nl: "Er is iets fout gegaan. Probeer het later opnieuw.",
  "en-US": "Something went wrong. Please try again later.",
  de: "Something went wrong. Please try again later.",
};

/**
 * Load locale messages (from Umbraco)
 **/
async function loadLocaleMessages(locale: string): Promise<TranslationResult> {
  const result: TranslationResult = {
    loaded: false,
    error: false,
  };
  await getTranslations(locale)
    .then((response) => {
      if (response.status === 200) {
        i18n.global.setLocaleMessage(locale, response.data);
        result.loaded = true;
      } else {
        result.loaded = false;
        result.error = true;
      }
    })
    .catch(() => {
      result.loaded = false;
      result.error = true;
      switch (locale) {
        case "en":
        case "en-US":
          result.message = generalErrorMessages["en-US"];
          break;
        case "de":
        case "de-DE":
          result.message = generalErrorMessages.de;
          break;
        default:
          result.message = generalErrorMessages.nl;
          break;
      }
    });

  return result;
}

const config = getGlobalConfig();

const i18n = createI18n({
  locale: config.locale,
  fallbackLocale: config.fallbackLocale,
});

const translationResult = loadLocaleMessages(config.locale);
loadLocaleMessages(config.locale);
if (config.fallbackLocale) {
  loadLocaleMessages(config.fallbackLocale);
}

export default i18n;

export function checkTranslations(): Promise<TranslationResult> {
  return translationResult;
}

export function getTranslation(key: string): string {
  const dictionary = useI18n();
  return dictionary.t(key);
}

export function hasTranslation(key: string): boolean {
  const value = getTranslation(key);
  //console.log("Get translation from key: "+ key)
  return value !== undefined && value !== "" && value !== key;
}

export function getCarSizeTranslation(name: string): string {
  const key = "own-car-type-option-" + name;
  return getTranslation(key);
}
